import * as React from "react";
import { Avatar } from "primereact/avatar";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import { useState, useRef } from "react";

import { Toast } from "primereact/toast";
import { Logout } from "./pages/logout/logoutPage/logout";
import Toolbar from "@mui/material/Toolbar";
import Logo from "./assets/logo.png";

import "./App.css";
import { Link, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Login } from "./pages/login/loginPage/login";
import { Client } from "./pages/client/ClientPage/client";

import ZotSuivis from "./pages/zotSuivis/zotSuivis";
import ZotSuivisToutes from "./pages/zotSuivis/zotSuivisToutes";

import Navettes from "./pages/zotSuivis/navette";

import { Users } from "./pages/users/usersPage/users";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "./styles/NavbarGauche.css";
import { Modal } from "@mui/material";
import { Menu } from "primereact/menu";
import { ListCat } from "./pages/categorie/categorie";

import ReactDOM from "react-dom";

import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";




const apiUrl = process.env.REACT_APP_API_URL;

const drawerWidth = 240;
function App(props) {
  const isMobilePortrait = useMediaQuery("(max-width:1400px) ");

  const [nomPageActive, setNomPageActive] = useState("");
  const locationGauche = useLocation();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();
  const menu = useRef(null);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch(`${apiUrl}IHM/api/zotCategorie.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setCategories(data.categories);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  let items = [
   

    {
      label: "Déconnexion",
      icon: "pi pi-power-off",
      command: () => {
        setdeconnect(true);
      },
    },
  ];

  if (
    localStorage.getItem("us") === "admin" ||
    localStorage.getItem("us") === "dev"
  ) {
    items.unshift({
      label: "Utilisateurs",
      icon: "pi pi-users",
      command: () => {
        navigate("/users");
      },
    });
    items.unshift( {
      label: "Catégories",
      icon: "pi pi-list",
      command: () => {
        navigate("/list");
      },
    });
  }

  const [deconnectHovered, setDeconnectHovered] = useState(false);
  const [deconnect, setdeconnect] = useState(false);

  const handleAvatarClick = (event) => {
    menu.current.toggle(event);
  };

  const drawer = (
    <div>
      <Divider />
      <div className="navbarGauche">
        <Link to="/">
          <img
            src={Logo}
            alt="Logo"
            style={{
              marginLeft: "5%",
              width: "100px",
              display: "block",
            }}
          />
        </Link>

        <Divider />

        <div className="divLink" key="toutes">
          <Link
            to="/"
            className={locationGauche.pathname === "/" ? "activeLink" : "ty"}
            onClick={() => setNomPageActive("Toutes")}
          >
            Vue globale
          </Link>
        </div>

        {categories
          .filter((cat) => cat.afficher_admin !== "0")
          .map((cat) => (
            <div className="divLink" key={cat.idtally}>
              <Link
                to={`/categorie/${cat.idtally}`}
                className={
                  locationGauche.pathname === `/categorie/${cat.idtally}`
                    ? "activeLink"
                    : "ty"
                }
                onClick={() => setNomPageActive(cat.title)}
              >
                {cat.title}
              </Link>
            </div>
          ))}

        <div className="divLink" key="navettes">
          <Link
            to="/navette"
            className={
              locationGauche.pathname === "/navette" ? "activeLink" : "ty"
            }
            onClick={() => setNomPageActive("navettes")}
          >
            Navette de transport
          </Link>
        </div>

      </div>

      <Divider />
    </div>
  );

  const toast = useRef(null);
  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {" "}
      <Box sx={{ display: "flex" }}>
        <ToastContainer />
        <Toast ref={toast} />
        <CssBaseline />
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
            borderBottom: "1px solid #e0e0e0",
            backgroundColor: "#f9fafb",
          }}
        >
          <Toolbar
            style={{
              backgroundColor: "#f9fafb",
              color: "#029fe4",

              justifyContent: "flex-end",
              gap: "20px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { sm: "none" } }}
              >
                <MenuIcon />
              </IconButton>
            </div>

            <div style={{ display: "flex", gap: "10px", alignItems: "end" }}>
              <a
                href="https://www.zotdevis.com/admin/devis.php"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#2fd406ff",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 12px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                DEVIS
              </a>

              <a
                href="https://box.lesdalonsdudemenagement.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#06b6d4",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 12px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                BOX
              </a>

              <a
                href="https://dem.zotdevis.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#f1c40f",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 12px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                DEM
              </a>
            </div>

            <div>
              <Tooltip title={localStorage.getItem("us")} arrow>
                <span style={{ cursor: "pointer" }} onClick={handleAvatarClick}>
                  <Avatar
                    shape="circle"
                    style={{ backgroundColor: "#2ecc71", color: "#ffffff" }}
                  >
                    {localStorage.getItem("us")?.charAt(0)}
                  </Avatar>
                </span>
              </Tooltip>
              <Menu
                model={items}
                popup
                ref={menu}
                appendTo={document.body}
                className="custom-menu"
                style={{ marginTop: "30px" }}
              />
            </div>

            <Modal
              open={deconnect}
              disableBackdropClick={true}
              aria-describedby="modal-modal-description"
            >
              <Logout onClose={() => setdeconnect(false)} />
            </Modal>
          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{
            width: { sm: drawerWidth },
            flexShrink: { sm: 0 },
          }}
          aria-label="mailbox folders"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            style={{ overflow: " hidden" }}
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: "auto",
                height: "auto",
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 2,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />

          <Routes>
            <Route path="/login" element={<Login />} />

            {/* <Route path="/" element={<Dash />} /> */}

            <Route path="/" element={<ZotSuivisToutes />} />

            <Route path="/categorie/:idtally" element={<ZotSuivis />} />

            <Route path="/users" element={<Users />} />

            <Route path="/list" element={<ListCat />} />

            <Route path="/navette" element={<Navettes />} />

            {isMobilePortrait ? null : <></>}
          </Routes>
        </Box>
        {isMobilePortrait ? (
          <>
            <Box
              sx={{
                flexGrow: 1,
                p: 3,
                marginLeft: `-${drawerWidth}px`,
              }}
            >
              <Toolbar />
              <Routes></Routes>
            </Box>
          </>
        ) : null}{" "}
        {isMobilePortrait ? (
          <>
            <Box
              sx={{
                flexGrow: 1,
                p: 3,
                marginLeft: `-95px`,
              }}
            >
              <Toolbar />
              <Routes></Routes>
            </Box>
          </>
        ) : null}{" "}
        {isMobilePortrait ? (
          <>
            <Box
              sx={{
                flexGrow: 1,
                p: 3,
                // marginLeft: `-${drawerWidth}px`,
              }}
              style={{ width: "90vw" }}
            >
              <Toolbar />
              <Routes>
                <Route path="/client" element={<Client />} />{" "}
              </Routes>
            </Box>
          </>
        ) : null}
      </Box>
    </LocalizationProvider>
  );
}

App.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  window: PropTypes.func,
};

export default App;
